"use client";
import React from "react";
import { Avatar, Box, SxProps, Typography, useTheme } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CountryFlag from "./CountryFlag"; // 경로는 필요에 따라 수정
import { urbanist } from "@/styles/fonts";
import { useAppStore } from "@/stores/appStore ";
import { useRouter } from "@/i18n/routing";
import { useSession } from "@/hook/useSession";
// 문자열의 첫 글자를 추출하는 함수
function getFirstLetter(name: string) {
  return name ? name.charAt(0).toUpperCase() : "";
}

function hexToRgba(hex: string, alpha: number = 1) {
  if (hex.startsWith("#")) hex = hex.slice(1);
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("");
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function getAlphabetFromUnicode(name: string) {
  const firstLetter = name.charAt(0);
  const unicodeValue = firstLetter.charCodeAt(0);
  return String.fromCharCode((unicodeValue % 26) + 65);
}

function getBackgroundColor(name: string) {
  const firstLetter = getAlphabetFromUnicode(name);
  const colors = [
    "#ff6f61",
    "#ffcc5c",
    "#6b5b95",
    "#feb236",
    "#d64161",
    "#6b4226",
    "#ffb7b2",
    "#ff7b9c",
    "#aec6cf",
    "#c0d6e4",
    "#f7cac9",
    "#92a8d1",
    "#034f84",
    "#9b1b30",
  ];
  const index = firstLetter.charCodeAt(0) % colors.length;
  return colors[index];
}

interface DebateAvatarProps {
  name: string;
  src?: string;
  size?: number;
  showHeart?: boolean;
  showFlag?: boolean;
  isSearch?: boolean;
  sx?: SxProps;
}

const DebateAvatar = ({
  name,
  src,
  size = 40,
  showHeart = false,
  showFlag = false,
  isSearch = true,
  sx,
}: DebateAvatarProps) => {
  const theme = useTheme();
  const firstLetter = getFirstLetter(name);
  const backgroundColor = getBackgroundColor(name);
  const isDarkMode = theme.palette.mode === "dark";
  const background = hexToRgba(backgroundColor, isDarkMode ? 0.9 : 0.8);
  const router = useRouter();
  const { setSearchTerm } = useAppStore();
  const { session } = useSession();
  function handleClickAvata(nickname: string): void {
    if (nickname && isSearch) {
      setSearchTerm(nickname);
      router.push("/search", {
        scroll: true,
      });
    }
  }

  return (
    <Box
      position="relative"
      sx={{ cursor: isSearch ? "pointer" : "default" }}
      width={size}
      height={size}
      onClick={() => handleClickAvata(name)}
    >
      <Avatar
        alt={name}
        src={src}
        sx={{
          width: size,
          height: size,
          backgroundColor: src ? undefined : background,
          fontSize: size / 2,
          color: isDarkMode ? "white" : "black",
          ...sx,
        }}
      >
        {!src && (
          <Typography
            component="span"
            fontFamily={urbanist.style.fontFamily}
            fontWeight={600}
            sx={{ textTransform: "uppercase" }}
          >
            {firstLetter}
          </Typography>
        )}
      </Avatar>

      {showHeart && (
        <FavoriteIcon
          sx={{
            position: "absolute",
            bottom: -2,
            right: -2,
            fontSize: size * 0.45,
            color: "#e53935",
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "1px",
          }}
        />
      )}

      {showFlag && (
        <Box position="absolute" bottom={-2} right={-10} zIndex={1}>
          <CountryFlag width={size * 0.5} height={size * 0.4} countryCode={session?.user.country} />
        </Box>
      )}
    </Box>
  );
};

export default DebateAvatar;
